import {Action} from '@ngrx/store';
import {type} from '../utils/type';
import {CATEGORY} from '../common/category.common';

export interface IFiscalActions {
    LOAD_FISCALS: string;
    LOAD_FISCALS_SUCCESS: string
    LOAD_FISCALS_FAILURE: string
}

export const ActionTypes: IFiscalActions = {
    LOAD_FISCALS: type(`${CATEGORY} Load Fiscals`),
    LOAD_FISCALS_SUCCESS: type(`${CATEGORY} Load Fiscals Success`),
    LOAD_FISCALS_FAILURE: type(`${CATEGORY} Load Fiscals Failure`)
};

export class LoadFiscalsAction implements Action {
    type = ActionTypes.LOAD_FISCALS;
    constructor(public payload: string) {}
}

export class LoadFiscalsSuccessAction implements Action {
    type = ActionTypes.LOAD_FISCALS_SUCCESS;
    constructor(public payload: any[]) {}
}

export class LoadFiscalsFailureAction implements Action {
    type = ActionTypes.LOAD_FISCALS_FAILURE;
    payload: string = null;
}

export type Actions
    = LoadFiscalsAction
    | LoadFiscalsSuccessAction
    | LoadFiscalsFailureAction
